import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

export interface HeaderState {
  title: string;
  description: string;
  visible: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  // Initialize with default values
  private headerSubject = new BehaviorSubject<HeaderState>({
    title: 'Dashboard',
    description: null,
    visible: true
  });

  // Observable that components can subscribe to
  headerState$ = this.headerSubject.asObservable();

  constructor() {}

  /**
   * Set the page title
   * @param title - The title to display
   */
  setTitle(title: string): void {
    const currentState = this.headerSubject.getValue();
    this.headerSubject.next({ ...currentState, title });
  }

  /**
   * Set the page description
   * @param description - The description to display
   */
  setDescription(description: string): void {
    const currentState = this.headerSubject.getValue();
    this.headerSubject.next({ ...currentState, description });
  }

  /**
   * Show the header
   */
  showHeader(): void {
    const currentState = this.headerSubject.getValue();
    this.headerSubject.next({ ...currentState, visible: true });
  }

  /**
   * Hide the header
   */
  hideHeader(): void {
    const currentState = this.headerSubject.getValue();
    this.headerSubject.next({ ...currentState, visible: false });
  }

  /**
   * Set the header state completely
   */
  setHeaderState(title: string, description: string = null, visible: boolean): void {
    this.headerSubject.next({ title, description, visible });
  }

}
